import Vue from "vue";
import VueNativeSock from "vue-native-websocket";
import store from "../store";

export function initialize_ws_connection () {
    let ws_hostname = ''
    if (Vue.prototype.$ws_hostname === null) ws_hostname = window.location.host
    else ws_hostname = Vue.prototype.$ws_hostname
    Vue.use(
        VueNativeSock,
    //Development
    // `ws://${window.location.host}/api/ws`,
        `ws://${ws_hostname}/api/ws`,
    //Production
    // 'ws://178.62.185.87:10702/api/ws',
    {store: store, reconnection: true, reconnectionDelay: 3000}
)
}